// Importing 3rd party dependencies
import moment from 'moment';
// ----------------------------------------------------------------------
export const useDate = () => {
    // Helper function to format date
    const formatDate = (date) => {
        return moment(date).format('DD.MM.YYYY');
    };
    // Returning all hook options
    return { formatDate };
};
